import styles from "./styles.module.css";
export const Line = () => <div className={`${styles.line} mx-5 hidden lg:block`}></div>;
